import { visuallyHidden } from "@mui/utils";
import { MarketplaceResultCardSkeleton } from "marketplace/_views/marketplace-result-card";

/** Enough cards to fill the pane a search replaces, so the page keeps its height while it loads. */
const LOADING_CARDS = 3;

type ResultSkeletonProps = {
  /** The vendor-team picker's cards: no description, two facts and the picker's button. */
  compact?: boolean;
};

/**
 * The results list while a search runs, drawn in the shape of the cards that will replace it. The
 * cards are hidden from a screen reader, which hears one "Loading results" instead of three empty
 * articles.
 */
export default function ResultSkeleton(props: Readonly<ResultSkeletonProps>) {
  return (
    <div role="status">
      <span style={visuallyHidden}>Loading results</span>
      {Array.from({ length: LOADING_CARDS }, (_, index) => (
        <MarketplaceResultCardSkeleton key={index} compact={props.compact} />
      ))}
    </div>
  );
}
